module.exports = __webpack_public_path__ + "images/star-filled9668c1b6cec1f6ef5d0c3815c0e3929a.svg";